import React from 'react';
import PropTypes from 'prop-types';

const ParentContext = React.createContext();

const ParentState = ({ backgroundColor, children }) => (
  <ParentContext.Provider
    value={{
      backgroundColor,
    }}
  >
    {children}
  </ParentContext.Provider>
);

ParentState.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

ParentState.defaultProps = {
  backgroundColor: '',
  children: null,
};

export default ParentState;

export { ParentContext };
